import { Theme } from '@mui/material';

export const locationSearchCtrStyles = {
	margin: { xs: '0.5rem 0', md: '1.5rem 0 0' },
	paddingX: '1.5rem',
	width: '100%',
	position: 'sticky',
	top: 0,
	zIndex: 1,
};

export const getLocationSearchTextInputStyles = (theme: Theme) => ({
	display: 'flex',
	width: '100%',
	height: '2.75rem',
	backgroundColor: 'neutrals.white',
	border: `1px solid ${theme.palette.neutrals?.primary}`,
	borderRadius: '0.5rem',
	paddingRight: '.75rem',
	'& input::placeholder': {
		opacity: 1,
		fontWeight: '350',
		color: 'text.primary',
		fontSize: '1rem',
	},
	'& fieldset': {
		border: 'none',
	},
});

export const locationSearchLocateMeBtnStyles = {
	display: 'flex',
	textWrap: 'nowrap',
	width: '100%',
	justifyContent: 'center',
	'.MuiButton-startIcon': {
		margin: { xs: '0' },
	},
};
